// ============================================================
// depotFichiers — déposer PLUSIEURS plans, un par un.
// ------------------------------------------------------------
// Philippe, 29 octobre 2026 (devis 2026-10-046, 34 documents) : « j'ai un
// paquet de plans à déposer, j'ai dû les prendre 1 par 1 ».
//
// La sélection est multiple et le glisser-déposer aussi ; l'ENVOI, lui,
// reste en file. Trente-quatre envois simultanés feraient trente-quatre
// lancements du traitement serveur qui se marchent dessus, et le premier
// délai dépassé emporterait les autres sans dire lequel.
//
// Un fichier refusé n'arrête pas la file : il garde SA raison (celle du
// serveur, qui nomme le format à fournir) et on passe au suivant.
// ============================================================

/** Les états d'un fichier dans la file, dans l'ordre où ils s'enchaînent. */
export const ETATS_DEPOT = ['attente', 'envoi', 'depose', 'deja', 'refuse'];

/** La file de départ : un élément par fichier, rien d'envoyé. */
export function fileDeDepot(fichiers) {
  return Array.from(fichiers ?? []).map((fichier, i) => ({
    cle: `${i}-${fichier.name}`, nom: fichier.name, fichier, etat: 'attente', detail: null,
  }));
}

/**
 * Envoie la file, un fichier après l'autre. `envoyer(fichier)` rend la
 * réponse du serveur ou lève son erreur ; `onChange(file)` reçoit la file
 * à chaque changement d'état. Rend la file finale.
 */
export async function deposerEnFile(file, envoyer, onChange = () => {}) {
  let courante = file.map((e) => ({ ...e }));
  const poser = (i, maj) => {
    courante = courante.map((e, j) => (j === i ? { ...e, ...maj } : e));
    onChange(courante);
  };
  for (let i = 0; i < courante.length; i += 1) {
    poser(i, { etat: 'envoi' });
    try {
      const res = await envoyer(courante[i].fichier);
      poser(i, res?.alreadyPresent
        ? { etat: 'deja', detail: 'déjà déposé sur ce devis' }
        : { etat: 'depose', detail: `${res?.pages?.length ?? 0} page(s)`, lancees: res?.traitement?.lancees ?? 0 });
    } catch (err) {
      poser(i, { etat: 'refuse', detail: err?.message ?? String(err) });
    }
  }
  return courante;
}

/** Une phrase pour toute la file — pas trente-quatre messages. */
export function bilanDepot(file) {
  const n = (etat) => file.filter((e) => e.etat === etat).length;
  const morceaux = [`${n('depose')} plan(s) déposé(s)`];
  if (n('deja')) morceaux.push(`${n('deja')} déjà présent(s)`);
  if (n('refuse')) morceaux.push(`${n('refuse')} refusé(s) — la raison est affichée`);
  return morceaux.join(', ');
}
